module.exports = __webpack_public_path__ + "img/previous.beed8209.svg";